// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".app-main[data-v-6beed8bc] {\n  z-index: 88;\n  /*84 = navbar + tags-view = 50 +34 */\n  min-height: calc(100vh - 50px);\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n.fixed-header + .app-main[data-v-6beed8bc] {\n  padding-top: 50px;\n}\n.hasTagsView .app-main[data-v-6beed8bc] {\n  min-height: calc(100vh - 50px);\n}\n.hasTagsView .fixed-header + .app-main[data-v-6beed8bc] {\n  padding-top: 85px;\n}", ""]);
// Exports
module.exports = exports;
